module.exports = __webpack_public_path__ + "static/icon-xiaowei.e7368c48.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-xiaowei.png
// module id = 297
// module chunks = 2